"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReservedKeyType = exports.WranggleReservedPrefix = void 0;
exports.WranggleReservedPrefix = '_$w_';
var ReservedKeyType;
(function (ReservedKeyType) {
    ReservedKeyType["TaskOutputControlData"] = "ctrl";
    /**
     * When a task returns a non-object (eg, string, array, etc) this reserved value is used as its item key/property
     */
    ReservedKeyType["SoloTaskOutputNonRecordAttrib"] = "solo";
    /**
     * Used when serializing task output. Presence indicates it should be deserialized before value can be used
     */
    ReservedKeyType["TaskOutputDataType"] = "dataType";
    ReservedKeyType["DataRef"] = "ref";
    ReservedKeyType["TaskWorkingData"] = "taskWip";
    ReservedKeyType["OrgApiSaveRequestData"] = "auxRequestData";
    ReservedKeyType["KahbaRuntimeState"] = "kahbaStepState";
    ReservedKeyType["KahbaRunnerStructureMarker"] = "out_";
    ReservedKeyType["KahbaRuntimeOutputFullDataItem"] = "result";
    ReservedKeyType["AutomationScriptFinalOutput"] = "done";
    /**
     * Used in generated script,
     * exposed to avoid conflicts with other reserved keys/names. Not referenced in other services.
     */
    ReservedKeyType["VarNameForTaskOutput"] = "taskResult";
    /**
     * Generally used as a prefix for redis sets, holding related keys as members of a set or sorted set.
     */
    ReservedKeyType["TrackingBucketMembersUnsortedSetPrefix"] = "track";
    /**
     * Generally used as a prefix for redis sets, holding related keys as members of a set or sorted set.
     */
    ReservedKeyType["TrackingBucketTimeSortedSetPrefix"] = "timeTrack";
})(ReservedKeyType = exports.ReservedKeyType || (exports.ReservedKeyType = {}));
//# sourceMappingURL=reserved-keys.js.map